import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M11.1361 3.48152C11.522 2.81981 12.478 2.81981 12.8639 3.48152L15.3992 7.82956L20.3204 8.89405C21.0698 9.05615 21.3655 9.96666 20.8543 10.5381L17.5 14.288L18.0073 19.2924C18.0845 20.0548 17.3108 20.6173 16.6095 20.3085L12 18.2796L7.39052 20.3085C6.68918 20.6173 5.91547 20.0548 5.99274 19.2924L6.5 14.288L3.14569 10.5381C2.63449 9.96666 2.93017 9.05615 3.67959 8.89405L8.60081 7.82956L11.1361 3.48152Z"
            fill="currentColor"
        />
    </svg>
);

export default Icon;
